import { EagerLoadImages, wrapCollectionLayout } from "@quintype/components";
import get from "lodash/get";
import React, { useEffect, useState } from "react";
import { deviceType } from "react-device-detect";
import { DfpComponent } from "../ads/dfp-component";
import { EMagazineWidgetBanner } from "../molecules";
import KeyAuthors from "../molecules/KeyAuthors";
import {
  ArrowElevenStories,
  ArrowFourColFiveStories,
  ArrowFourColGrid,
  ArrowFourColPortraitStories,
  ArrowFourColTwelveStories,
  ArrowFullScreenSlider,
  ArrowOneColStoryList,
  ArrowThreeColGrid,
  ArrowThreeColSevenStories,
  ArrowThreeColTwelveStories,
  ArrowTwoColFourStories,
} from "./arrow-rows";
import { FourColTenStories } from "./four-col-ten-stories";
import { FromOurMagazines } from "./from-our-magazines";
import { LatestMagazineIssues } from "./latest-magazine-issues";
import TopRowComponent from "../../arrow/components/Rows/TopRowComponent";
import FourColSlider from "../../arrow/components/Rows/FourColSlider";
import LifestyleRow from "../../arrow/components/Rows/LifestyleRow";
import GoAdFreeWidgetRed from "../molecules/GoAdFreeWidgetRed";
import NewsletterWidget from "../molecules/NewsletterWidget";

function wrapAd(Component) {
  const WrappedComp = function (props) {
    const network_id = get(props, ["config", "ads-config", "network_id"], {});
    const pageType = props.pageType;
    const isAdfreePage = get(props, ["config", "subscriber"]) === "true";
    const [inPageAdConfig, setInPageAdConfig] = useState({});
    const associatedMetadata = get(props, ["collection", "associated-metadata"], {});
    // Set in page ad config based on the device. Skip the check for server side rendering as the device width is not available.
    useEffect(() => {
      const device = deviceType === "browser" ? "desktop" : deviceType;
      const deviceSpecificAdPath = get(associatedMetadata, [`${device}_ad_unit_path`], "");
      const deviceSpecificAdConfigName = get(associatedMetadata, [`${device}_ad_config_name`], "");

      // Make this check for ads that are rendered on tablet
      if (deviceSpecificAdPath && deviceSpecificAdConfigName) {
        setInPageAdConfig({
          ...inPageAdConfig,
          ad_unit: deviceSpecificAdPath,
          ad_config_name: deviceSpecificAdConfigName,
        });
      }
    }, []);

    const path = `/${network_id}/${get(inPageAdConfig, ["ad_unit"], "")}`;
    const adSlotConfigName = `${get(inPageAdConfig, ["ad_config_name"], "")}`;
    return (
      <React.Fragment>
        <Component {...props} />
        {!isAdfreePage && inPageAdConfig.ad_unit && inPageAdConfig.ad_config_name && (
          <DfpComponent
            id={`${pageType}-collection-row-ad-${props.index}`}
            path={path}
            adSlotConfigName={adSlotConfigName}
          />
        )}
      </React.Fragment>
    );
  };
  if (Component.storyLimit) {
    WrappedComp.storyLimit = Component.storyLimit;
  }
  if (Component.nestedCollectionLimit) {
    WrappedComp.nestedCollectionLimit = Component.nestedCollectionLimit;
  }
  return WrappedComp;
}

// This should not be needed anymore as we are using Gumlet
function wrapEager(f) {
  const wrappedComponent = function WrapEager(props) {
    if (props.index === 0) {
      return (
        <EagerLoadImages predicate={(token) => token === "above-fold"}>{React.createElement(f, props)}</EagerLoadImages>
      );
    } else {
      return React.createElement(f, props);
    }
  };

  if (f.storyLimit) {
    wrappedComponent.storyLimit = f.storyLimit;
  }

  if (f.nestedCollectionLimit) {
    wrappedComponent.nestedCollectionLimit = f.nestedCollectionLimit;
  }

  return wrappedComponent;
}

export default {
  ArrowFourColTwelveStories: wrapAd(wrapEager(wrapCollectionLayout(ArrowFourColTwelveStories))),
  ArrowThreeColGrid: wrapAd(wrapEager(wrapCollectionLayout(ArrowThreeColGrid))),
  ArrowFourColGrid: wrapAd(wrapEager(wrapCollectionLayout(ArrowFourColGrid))),
  ArrowElevenStories: wrapAd(wrapEager(wrapCollectionLayout(ArrowElevenStories))),
  ArrowTwoColFourStories: wrapAd(wrapEager(wrapCollectionLayout(ArrowTwoColFourStories))),
  ArrowFullScreenSlider: wrapAd(wrapEager(wrapCollectionLayout(ArrowFullScreenSlider))),
  ArrowOneColStoryList: wrapAd(wrapEager(wrapCollectionLayout(ArrowOneColStoryList))),
  ArrowThreeColSevenStories: wrapAd(wrapEager(wrapCollectionLayout(ArrowThreeColSevenStories))),
  FourColTenStories: wrapAd(wrapEager(wrapCollectionLayout(FourColTenStories))),
  ArrowFourColFiveStories: wrapAd(wrapEager(wrapCollectionLayout(ArrowFourColFiveStories))),
  KeyAuthors: wrapEager(wrapCollectionLayout(KeyAuthors)), // Widget Row
  LatestMagazineIssues: wrapAd(wrapEager(wrapCollectionLayout(LatestMagazineIssues))),
  EMagazineWidgetBanner: wrapEager(wrapCollectionLayout(EMagazineWidgetBanner)), // Widget Row
  GoAdFreeWidget: wrapEager(wrapCollectionLayout(GoAdFreeWidgetRed)), // Widget Row
  NewsletterWidget:wrapEager(wrapCollectionLayout(NewsletterWidget)), // Widget Row
  ThreeColTwelveStories: wrapAd(wrapEager(wrapCollectionLayout(ArrowThreeColTwelveStories))),
  ArrowFourColPortraitStories: wrapAd(wrapEager(wrapCollectionLayout(ArrowFourColPortraitStories))),
  FromOurMagazines: wrapAd(wrapEager(wrapCollectionLayout(FromOurMagazines))),
  TopRowComponent: wrapAd(wrapEager(wrapCollectionLayout(TopRowComponent))),
  FourColSlider: wrapAd(wrapEager(wrapCollectionLayout(FourColSlider))),
  LifestyleRow: wrapAd(wrapEager(wrapCollectionLayout(LifestyleRow))),
  defaultTemplate: wrapAd(wrapEager(wrapCollectionLayout(ArrowFourColGrid))),
};
